import { render, staticRenderFns } from "./Stepper2.vue?vue&type=template&id=8089ba60&scoped=true&"
var script = {}
import style0 from "./Stepper2.vue?vue&type=style&index=0&id=8089ba60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089ba60",
  null
  
)

export default component.exports